import React, { useContext, useEffect, useState } from 'react';

import { RouteComponentProps } from '@reach/router';

import { GlobalContext } from '../../../store';

import { InnerRouter } from '../../../components/AnimatedRouter';
import { EventWizardNavigator } from './Components/EventWizardNavigator/EventWizardNavigator';
import { useRouteInfoState } from '../../../components/RouteInfo/Context/RouteInfo.context';

interface IProps extends RouteComponentProps {
  children: any;
  clubId: number;
  eventId?: number;
}

export const EventWizard = (props: IProps) => {
  const { children, location, clubId } = props;

  const {
    adminEvents,
    actions: {
      adminClubCreditCard: { get: getAdminClubCreditCard },
      adminCourses: { all: getAllCourses },
      adminEventEnrollments: { get: getEnrollments },
      adminEvents: { get: getAdminEvents, setCurrent: setCurrentAdminEvent },
      adminInvitations: { getByEvent: getInvitationsByEvent }
    }
  } = useContext(GlobalContext);

  const { eventId } = useRouteInfoState();

  const [currentPage, setCurrentPage] = useState<string>('setup');
  const [currentRound, setCurrentRound] = useState<number>(0);

  useEffect(() => {
    if (eventId && clubId && String(eventId) !== 'new') {
      getAdminEvents(Number(clubId), Number(eventId)).catch();
      getInvitationsByEvent(Number(eventId));
      getEnrollments(Number(clubId), Number(eventId));
    }

    getAllCourses();
    getAdminClubCreditCard(clubId);
  }, [eventId, clubId]);

  useEffect(() => {
    if (adminEvents && adminEvents[Number(eventId)]) {
      setCurrentAdminEvent(adminEvents[Number(eventId)]).catch();
    }
  }, [eventId, adminEvents[Number(eventId)]]);

  useEffect(() => {
    const groups = location
      ? /staff\/club\/[0-9]+\/event\/[0-9]+\/([a-z\-]+)/g.exec(location.pathname || '')
      : [];

    const roundLocationGroups = location
      ? /staff\/club\/[0-9]+\/event\/[0-9]+\/round\/([0-9\-]+)/g.exec(location.pathname || '')
      : [];

    setCurrentPage(groups && groups.length > 1 ? groups[1] : 'setup');
    setCurrentRound(
      roundLocationGroups && roundLocationGroups.length > 1 ? Number(roundLocationGroups[1]) : 0
    );
  }, [location]);

  return eventId && clubId ? (
    <div className="admin-layout event-wizard">
      <EventWizardNavigator currentPage={currentPage} currentRound={currentRound} />

      {children && (
        <InnerRouter
          location={location}
          className="event-wizard-router"
          transitionKey={currentPage === 'round' ? currentPage + currentRound : currentPage}
        >
          {children}
        </InnerRouter>
      )}
    </div>
  ) : (
    <></>
  );
};
